module.exports = __webpack_public_path__ + "img/gw2.f4eecfaf.png";